export default "__VITE_ASSET__BADUplpp__"